import { Boxes, PriceDVGT } from "../models";

export class ShipmentCalculateViewModel {
    isBuy: boolean = false;
    tplId?: number;
    disCount: number;
    priceListId: number;
    priceServiceId: number;
    orderDate: any;
    fromHubId: number;
    senderId: number;
    fromDistrictId: number;
    fromWardId: number;
    toProvinceId: number;
    toDistrictId: number;
    weight: number;
    serviceId: number;
    paymentTypeId: number;
    structureId: number;
    cod: number;
    insured: number;
    otherPrice: number;
    serviceDVGTIds: number[];
    isAgreementPrice: boolean;
    defaultPrice: number;
    fuelPrice: number;
    remoteAreasPrice: number;
    totalDVGT: number;
    totalItem: number;
    calWeight: number;
    toWardId: number;
    priceBox: Boxes[];
    priceDVGTs: PriceDVGT[];
    priceDVGTNoVAT:PriceDVGT[];
    priceReturn: number;
    distance: number;
    totalBox: number;
    isReturn: boolean;
    isVAT: boolean;
    createdWhen: any
    truckingPrice:number=0;
    isPickUp:boolean;
    pickUpPrice:number=0;
    tplTruckingPrice:number=0;
    isTplPickUp:boolean;
    tpPickUpPrice:number=0;
    isTruckDelivery:boolean=false;
}